import { pickFirstString } from './partnerUserUtils';

const normalizeUserId = (user) => (
  user?.id
  || user?._id
  || user?.userId
  || user?.email
  || null
);

export const normalizePartnerCompanyUser = (user) => {
  if (!user || typeof user !== 'object') {
    return null;
  }

  const partnerName = pickFirstString(
    user.partnerName,
    user.fullname,
    user.fullName,
    user.name,
    user.user,
    [user.firstname, user.lastname].filter(Boolean).join(' '),
    user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : '',
  );

  return {
    id: normalizeUserId(user),
    partnerName: partnerName || '-',
    email: pickFirstString(user.email, user.partnerEmail, user.partner_email) || '-',
    reason: pickFirstString(user.reason, user.assignmentReason, user.accessReason) || '-',
    manager: pickFirstString(user.manager, user.managerName, user.reportingManager) || '-',
  };
};

export const normalizePartnerCompanyUsers = (users) => {
  if (!Array.isArray(users)) {
    return [];
  }

  return users
    .map(normalizePartnerCompanyUser)
    .filter(Boolean);
};

export const normalizePartnerCompanyRecord = (company) => {
  if (!company || typeof company !== 'object') {
    return company;
  }

  const users = normalizePartnerCompanyUsers(
    company.users
    || company.partnerUsers
    || company.assignedUsers
    || company.userDetails
    || [],
  );

  return {
    ...company,
    id: company.id || company._id || company.csn || company.companyName,
    users,
  };
};

export const normalizePartnerCompaniesList = (companies) => {
  if (!Array.isArray(companies)) {
    return [];
  }

  return companies.map(normalizePartnerCompanyRecord);
};

export const getCompanyRowKey = (company) => (
  company?.id
  || company?._id
  || company?.csn
  || company?.companyName
  || 'company'
);
